import { render } from "./EmailSubmitCard.vue?vue&type=template&id=9529be4e&scoped=true"
import script from "./EmailSubmitCard.vue?vue&type=script&lang=js"
export * from "./EmailSubmitCard.vue?vue&type=script&lang=js"

import "./EmailSubmitCard.vue?vue&type=style&index=0&id=9529be4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9529be4e"]])

export default __exports__